import { type FC } from 'react'
import * as Styled from './styled'

interface IAiSparkleIconProps {
  className?: string
}
export const AiSparkleIcon: FC<IAiSparkleIconProps> = props => (
  <Styled.AiSparkleIcon {...props} />
)
